import { SERVICE_AREA } from '../store/areas';
export const DIGITAL_AREA = 'digital';
export const PREOWNED_AREA = 'preowned';
export const SHOWROOM_AREA = 'showroom';
export const BDC_AREA = 'bdc';

export const USER_AREAS_ARRAY = [DIGITAL_AREA, SHOWROOM_AREA, BDC_AREA, SERVICE_AREA];

export type TUserArea =
    | typeof DIGITAL_AREA
    | typeof SHOWROOM_AREA
    | typeof BDC_AREA
    | typeof SERVICE_AREA
    | typeof NEW_CARTYPE
    | typeof PREOWNED_CARTYPE
    | typeof BOTH_DIGITAL_CARTYPE;

export interface IUserAreaObject {
    _id: string;
    name: TUserArea;
}

export interface IUserAreaObjects {
    data: IUserAreaObject[];
}

export type TUserAreas = (typeof USER_AREAS_ARRAY)[number];

export const NEW_CARTYPE = 'nuevo';
export const PREOWNED_CARTYPE = 'seminuevo';
export const BOTH_DIGITAL_CARTYPE = 'ambos';
export const BDC_CARTYPE = 'bdc';

export const USER_CAR_TYPES_ARRAY = [
    NEW_CARTYPE,
    PREOWNED_CARTYPE,
    BOTH_DIGITAL_CARTYPE,
];

export type TUserCarType = (typeof USER_CAR_TYPES_ARRAY)[number];

export const USER_LEAD_TYPE_LEAD = 'lead';
export const USER_LEAD_TYPE_SHOWROOM = 'showroom';
export const USER_LEAD_TYPE_ALL = 'all';

export const USER_LEAD_TYPES_ARRAY = [
    USER_LEAD_TYPE_LEAD,
    USER_LEAD_TYPE_SHOWROOM,
    USER_LEAD_TYPE_ALL,
];

export type TUserLeadTypes = (typeof USER_LEAD_TYPES_ARRAY)[number];
